import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import Footer from '../components/Footer';
import { ReCaptchaProvider } from '../reusable-components/recatcha-provider';
import ScrollToTop from '../components/ScrollToTop';
import AnalyticsTracker from '../components/AnalyticsTracker';

function RootLayout() {
  return (
    <ReCaptchaProvider>
      <ScrollToTop />
      <AnalyticsTracker />
      <NavigationBar />
      <Outlet />
      <Footer />
    </ReCaptchaProvider>
  );
}

export default RootLayout;
